import { action, observable, makeAutoObservable } from 'mobx';
import { makePersistable, isHydrated } from 'mobx-persist-store';
import { VIRTUAL_BACKGROUNDS } from 'consts';
import { ProcessorInfo } from 'features/VirtualBackground/types';

class VirtualBackgroundStore {
    @observable public isVirtualBackgroundEnabled: boolean = false;
    @observable public activeProcessor: string | null = null;
    @observable public availableProcessors: Map<string, ProcessorInfo> = new Map();
    @observable public isBackgroundProcessorLoading: boolean = false;

    public constructor() {
        makeAutoObservable(this);
        makePersistable(this, {
            name: VIRTUAL_BACKGROUNDS,
            properties: ['activeProcessor', 'availableProcessors'],
            storage: window.localStorage,
        });
    }

    @action
    public setIsVirtualBackgroundEnabled = (isVirtualBackgroundEnabled: boolean) => {
        this.isVirtualBackgroundEnabled = isVirtualBackgroundEnabled;
    };

    @action
    public setActiveProcessor = (activeProcessor: string) => {
        this.activeProcessor = activeProcessor;
    };

    @action
    public addAvailableProcessor = (key: string, newProcessor: ProcessorInfo) => {
        this.availableProcessors.set(key, newProcessor);
    };

    @action
    public appendAvailableProcessors = (availableProcessors: Map<string, ProcessorInfo>) => {
        this.availableProcessors = new Map([...this.availableProcessors, ...availableProcessors]);
    };

    @action
    public setIsBackgroundProcessorLoading = (isBackgroundProcessorLoading: boolean) => {
        this.isBackgroundProcessorLoading = isBackgroundProcessorLoading;
    };

    public get isHydrated() {
        return isHydrated(this);
    }
}

export const virtualBackgroundStore = new VirtualBackgroundStore();
